'use client';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import dynamic from 'next/dynamic';
import { useEffect, useRef, useState } from 'react';
const EcoCreditsWinIn: any = dynamic(() => import('@elem/compCommon/EcoCreditsWin/EcoCreditsWinIn'), { ssr: false });
export default function EcoCreditsWinEnterA() {
    const [isOpenA, setIsOpenA] = useState(false);
    const timer = useRef<any>(null);

    // 关闭
    const closeHandle = () => {
        setIsOpenA(false);
        EcoDesignEventsBus.emit('widgets-EcoCreditsWin-close-1');
    };

    const show = () => {
        EcoDesignEventsBus.emit('widgets-EcoCreditsWin-open');
    };

    const hide = () => {
        EcoDesignEventsBus.emit('widgets-EcoCreditsWin-close-1');
        EcoDesignEventsBus.emit('widgets-EcoCreditsWin-close-2');
    };

    useEffect(() => {
        EcoDesignEventsBus.on('widgets-EcoCreditsWin-open', () => {
            if (timer.current) {
                clearTimeout(timer.current);
                timer.current = null;
            }
            setIsOpenA(true);
        });
        EcoDesignEventsBus.on('widgets-EcoCreditsWin-close-2', () => {
            timer.current = setTimeout(() => {
                setIsOpenA(false);
            }, 300);
        });
    }, []);
    return <>{isOpenA && <EcoCreditsWinIn closeHandle={closeHandle} show={show} hide={hide} isOpenA={isOpenA} />}</>;
}
